<template>
  <b-list-group-item v-if="dataItem.safe">
    <div class="font-weight-bold text-primary">
      Kasa Hesabı
    </div>
    <div>{{ dataItem.safe }}</div>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'SafeAccount',
  components: {
    BListGroupItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
